import  VConsole from 'vconsole'
import { init } from 'Utils/back';

// 初始化浏览器按钮返回事件，一定要早于vue-router初始化
init();

let localHost = window.location.host
if (localHost.indexOf('tianxiafen.com') > 0) {
  new VConsole()
}

import Vue from 'vue'
import App from './App.vue'
import Common from 'Common'
import router from 'Plugins/router'
import store from 'Plugins/store'
import inject from 'Plugins/inject'
import Directives from 'Plugins/directives'
import Vant from 'Plugins/vant'
import 'Utils/filter'
import VueClipBoard from 'vue-clipboard2'




window.Vue = Vue
Vue.config.devtools = true
Vue.config.productionTip = true

Vue.use(Common)
Vant(Vue)
Vue.use(inject)
Vue.use(Directives)
Vue.use(VueClipBoard)
//vue-echarts
import ECharts from "vue-echarts";
Vue.component('v-chart', ECharts)//全局注册

// 小程序 web-view下的页面内
if (!window.WeixinJSBridge || !window.WeixinJSBridge.invoke) {
  document.addEventListener('WeixinJSBridgeReady', ready, false)
} else {
  ready()
}

function ready() {
  if (window.__wxjs_environment === 'miniprogram') {
    window.wx_min = true
  }
}

let vue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

export default vue
